export const IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME = 'IsCopilotProactiveDraft';
// TODO: Remove after the new server property rollout completes and legacy drafts age out.
export const PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME = 'ProactiveDraftGenerationProperties';
